var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.593 3.114H5.401c-.913 0-1.12.49-1.12 1.119v1.405H6.53l-.281 2.248H4.28v5.755H1.966V7.886H0V5.638h1.966V3.953a2.718 2.718 0 012.878-2.95c.774 0 1.476.07 1.759.07l-.01 2.04z","fill":"#172138"}));
}

FacebookInline.defaultProps = {"viewBox":"0 0 7 14","fill":"none"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
